import styled from 'styled-components';
import { Col, Container, Row } from 'components/atoms/Grid';
import Colors from 'components/tokens/Colors';
import Text from 'components/atoms/Text';
import AspectRatio from 'components/atoms/AspectRatio';
import { sbEditable } from '@storyblok/storyblok-editable';
import { getAssetURL } from 'helpers/getAssetURL';
import Link from 'components/atoms/Link';
import RouterLink from 'components/atoms/RouterLink';
import { useEditor } from 'providers/generalContext';
import Button from 'components/atoms/Button';
import placeholder from 'assets/image_placeholder.png';
import { render } from 'storyblok-rich-text-react-renderer';

export default function CheckTools(props) {
    const { isStoryblokEditor } = useEditor();

    return (
        <MainContent {...sbEditable(props)}>
            <Container style={{ position: 'relative' }} px="1.5 1">
                <Row alignItems="center" pt="8 2" pb="8 14">
                    <Col mb="3 35" size="12 5" pl="1 4">
                        <Row>
                            <Col size="12" mb="2 3" mt="2 5">
                                <Text size="16" lineHeight="22 24">
                                    {props?.subtitle}
                                </Text>
                            </Col>
                            <Col size="12" mb="7.5" className="title">
                                <Text size="48 56" lineHeight="40 48" title color={Colors.orange}>
                                    {props?.title}
                                </Text>
                            </Col>
                            <Col size="12 hidden">
                                {props?.image?.filename && (
                                    <AspectRatio bg={getAssetURL(props?.image?.filename) || placeholder} ratio={90} />
                                )}
                            </Col>
                        </Row>
                    </Col>
                    <StyledCol size="12 6" pl="1 6">
                        <Row>
                            <Col size="hidden 12" style={{ height: '165px' }} />
                            <Col size="12" mb="3 2">
                                <Text size="20" lineHeight="22 24" highlight>
                                    {props?.subtitle_2}
                                </Text>
                            </Col>
                            <Col size="12 10" mb="5">
                                <Text body2>{render(props?.description)}</Text>
                            </Col>
                            <Col size="12 7">
                                {props.button?.[0]?.link?.cached_url?.includes('http') ? (
                                    <Link
                                        href={props.button?.[0]?.link?.cached_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <Button dark>{props?.button?.[0]?.text}</Button>
                                    </Link>
                                ) : (
                                    <RouterLink to={`/${props.button[0].link?.cached_url}`} editor={isStoryblokEditor}>
                                        <Button dark>{props?.button?.[0]?.text}</Button>
                                    </RouterLink>
                                )}
                            </Col>
                        </Row>
                    </StyledCol>
                </Row>

                {props?.image?.filename && (
                    <StyledImage src={getAssetURL(props?.image?.filename) || placeholder} alt={props?.image?.alt} />
                )}
            </Container>
        </MainContent>
    );
}

const StyledCol = styled(Col)`
    @media (min-width: 820px) {
        height: 600px;
    }
`;

const MainContent = styled.div`
    position: relative;
    width: 100%;
    background-color: ${Colors.lightGrey};
`;

const StyledImage = styled.img`
    position: absolute;
    z-index: 1;
    display: none;
    width: 38.5%;
    left: 64px;
    top: 270px;

    @media (min-width: 820px) {
        display: block;
    }

    @media (min-width: 1400px) {
        bottom: -13%;
    }

    @media (min-width: 1600px) {
        bottom: -15%;
    }
`;
